import type { Step } from '@/types'

/** Objective-specific steps: Sexual Health (disfuncao_eretil) */
export const sexualHealthSteps: Step[] = []
